import { Component, OnInit } from "@angular/core";

@Component({
  selector: "shirase-t-footer",
  templateUrl: "./t-footer.component.html",
  styleUrls: ["./t-footer.component.scss"],
})
export class TFooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
